export const SOFTLINE_API_UPDATE_SHELF_LABEL_BASE =
  '/update-shelf-label-service/update-shelf-label-service';

export const SOFTLINE_API_QUERY_SHELF_LABELS = `${SOFTLINE_API_UPDATE_SHELF_LABEL_BASE}/query`;
export const SOFTLINE_API_UPDATE_SHELF_LABEL_DEFINITION = `${SOFTLINE_API_UPDATE_SHELF_LABEL_BASE}/label-definitions/{{id}}`;
export const SOFTLINE_API_UPDATE_SHELF_LABEL_PRINT = `${SOFTLINE_API_UPDATE_SHELF_LABEL_BASE}/print`;
